import {styled} from "@mui/system";
import {Select} from "@mui/material";

export const RbFilledSelect = styled(Select)(() => ({
    "& .MuiSelect-filled": {
        paddingTop: "0.4rem",
    },
}));
